import { FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import useTranslation from 'Hooks/useTranslation';
import { HeadingProps } from 'Containers/Validations/types';
import { openLinkInNewTab } from 'Utils/links';
import * as Styled from '../../styles';

const Heading = ({ title, info, buttonMode = 'success_light' }: HeadingProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.VALIDATIONS);
  return (
    <FlexContainer>
      <Text type="headline" size="S_L_S" color="dark">
        {title}
        {info && (
          <Styled.HelpButton
            mode={buttonMode}
            onClick={() => openLinkInNewTab(info)}
            label={t('Contextual.Help')}
          />
        )}
      </Text>
    </FlexContainer>
  );
};

export default Heading;
